<template>
  <div id="externalSupport">
    
    <div class="vo-external-card">
      <vo-external-header :title="title"></vo-external-header>

      <div class="vo-body">
        
        <div class="vo-title">{{ title }}</div>
        
        <div class="vo-context">Having issues with Vilio? Have a question? Let us know and we'll get back to you as soon as possible. You can also try using our <a :href="feedback" target="_blank">Feedback system</a> to report bugs, give suggestions, and help shape the future of Vilio.</div>

        <v-text-field :disabled="lockout" :validate-on-blur="$refs.emailInput && $refs.emailInput.valid" label="Email Address" ref="emailInput" type="email" v-model="email" :rules="rules.email"></v-text-field>

        <v-text-field :disabled="lockout" :validate-on-blur="$refs.messageInput && $refs.messageInput.valid" label="Message..." ref="messageInput" type="text" multi-line maxrows="3" maxlength="2000" no-resize v-model="message" :rules="rules.message"></v-text-field>
        
      </div>

      <v-btn block flat class="vo-card-button" :loading="lockout" v-ripple @click="sendMessage">SEND MESSAGE</v-btn>
    </div>

  </div>
</template>


<script>

  export default {
    data () {
      return {
        title: 'Vilio Support',
        email: '',
        message: '',
        lockout: false,
        rules: {
          email: [
            function (e) {
              return !window.regex.email.test(e) ? 'Please enter a valid email.' : true;
            }.bind(this)
          ],
          message: [
            function (e) {
              return (e.length < 10) ? 'Please enter a longer message.' : true;
            }.bind(this)
          ]
        }
      }
    },

    computed: {
      
      feedback () {
        return EXTERNAL_URLS.feedback.resident;
      }

    },

    methods: {
      
      sendMessage () {
        if (this.lockout) return;
        this.lockout = true;

        // Validate
        var valid = this.validateForm();
        
        if (!valid) { 
          Toast.show('Please correct the highlighted errors.', 'error');
          this.lockout = false;
          return;
        }

        // Send message
        this.$store.dispatch('contactMessage', {
          email: this.email,
          message: this.message
        })
        .then(data => {
          this.lockout = false;
          this.resetForm();
          Toast.show('Your message has been sent.', 'success');
        })
        .catch(e => {
          this.lockout = false;
          console.log('Error:', e);
          Toast.showError(e);
        });

      },
      
      // validateForm() - Validates all inputs, returns whether or not ALL inputs are valid
      validateForm () {

        this.$refs.emailInput.validate(true);
        this.$refs.messageInput.validate(true);

        return (this.$refs.emailInput.valid && this.$refs.messageInput.valid);
      },

      resetForm () {
        this.email = '';
        this.message = '';
      },

      initForm () {
        this.$refs.emailInput.valid = true;
        this.$refs.messageInput.valid = true;
      }

    },

    mounted () {

      // Initialize form (inputs are templated after 1 tick)
      this.$nextTick( () => {
        this.initForm();
      });

    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #externalSupport {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    @include scrollable;
  }

  @media screen and (max-width: 780px) {
   
    #externalSupport {
      
      background: $lightGreen !important;

      .vo-title {
        display: none;
      }
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/ExternalSupport.vue